import { Charts } from './Charts';
import ProceduresChartsDataProvider from './contexts/ProceduresChartsDataContext';

const ProceduresWrapper = () => {
    return (
        <ProceduresChartsDataProvider>
            <Charts />
        </ProceduresChartsDataProvider>
    );
};

export default ProceduresWrapper;
